import React from "react";
import { useAuth } from "../context/AuthContext";
import { Navigate, useLocation } from "react-router-dom";

export default function ProtectedRoute({ children }) {
    const { user, checking } = useAuth();
    const location = useLocation();

    if (checking) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-[#0B1220]">
                <div className="text-sm text-[#64748B] tracking-wider uppercase">Checking session…</div>
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/admin/login" state={{ from: location }} replace />;
    }

    if (user.role !== "admin") {
        return <Navigate to="/" replace />;
    }

    return children;
}
